export default __webpack_public_path__ + "static/media/calypso-mango-pistachio-pavlova-wreath.c2bba48e.png";